import React from "react";

const BADGES = [
  { initials: "APMA", line1: "American Podiatric", line2: "Medical Association" },
  { initials: "SLEEP", line1: "Independent Sleep", line2: "Lab Certified" },
  { initials: "OEKO", line1: "OEKO-TEX®", line2: "Standard 100" },
  { initials: "RDS", line1: "Responsible", line2: "Down Standard" },
];

export default function DoctorApproved() {
  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-16 items-center max-w-6xl mx-auto">
          <div>
            <span className="section-pill">🩺 Clinically endorsed</span>
            <h2 className="mt-5 text-[32px] sm:text-[42px] md:text-[52px] leading-[1.04] font-black tracking-[-0.02em] text-[#0e0e10]">
              Doctor-approved
              <br />
              luxury,
              <br />
              <span className="text-[#8a8a8a]">science-backed sleep.</span>
            </h2>
            <p className="mt-6 text-[#5a5a60] text-[15px] md:text-[16px] leading-relaxed max-w-xl">
              Developed alongside sleep specialists and orthopedic consultants in Dubai
              and Vienna. Independent labs in Europe have certified our materials for
              <strong className="text-[#0e0e10]"> spinal alignment, breathability and
              hypoallergenic safety</strong> — the same standards used by 7-star hotels.
            </p>

            <div className="mt-7 grid sm:grid-cols-2 gap-3 max-w-md">
              <div className="bg-white rounded-2xl border border-black/5 p-4">
                <div className="text-[22px] font-black text-[#0e0e10]">97%</div>
                <div className="text-[12px] text-[#6b6b72] leading-tight mt-1">
                  report less neck stiffness within 14 nights
                </div>
              </div>
              <div className="bg-white rounded-2xl border border-black/5 p-4">
                <div className="text-[22px] font-black text-[#0e0e10]">+47%</div>
                <div className="text-[12px] text-[#6b6b72] leading-tight mt-1">
                  deeper REM sleep vs synthetic pillows
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[5/6] rounded-[32px] overflow-hidden bg-white shadow-xl border border-black/5">
              <img
                src="/assets/ugc_woman_2.png"
                alt="Customer experiencing better sleep"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="sticker sticker-sky absolute -top-3 -left-3 text-[12px]">
              Lab-tested
              <br />
              in Vienna 🇦🇹
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-4xl mx-auto">
          {BADGES.map((b) => (
            <div
              key={b.initials}
              className="bg-white rounded-2xl border border-black/5 p-5 text-center hover:bg-[#faf8f4] transition-colors"
            >
              <div className="mx-auto w-14 h-14 rounded-full border-2 border-[#0e0e10] flex items-center justify-center text-[11px] font-black tracking-wider text-[#0e0e10] mb-2">
                {b.initials}
              </div>
              <div className="text-[11px] font-bold uppercase tracking-wider text-[#0e0e10]">
                {b.line1}
              </div>
              <div className="text-[10px] text-[#8a8a8a] uppercase tracking-wider mt-0.5">
                {b.line2}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
